let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ek3u")).then(() => parcelRequire('3rHYj'));